import { render, staticRenderFns } from "./AppTopAndSideBar.vue?vue&type=template&id=f0214b3a&scoped=true&"
import script from "./AppTopAndSideBar.vue?vue&type=script&lang=js&"
export * from "./AppTopAndSideBar.vue?vue&type=script&lang=js&"
import style0 from "./AppTopAndSideBar.vue?vue&type=style&index=0&id=f0214b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0214b3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VAppBarNavIcon,VChip,VDivider,VIcon,VImg,VNavigationDrawer,VSpacer})
